import { Injectable } from '@angular/core';
import { JhiLanguageService, EventManager } from 'ng-jhipster';

import { Principal } from '../auth/principal.service';
import { AuthServerProvider } from '../auth/auth-jwt.service';
import { JhiTrackerService } from '../tracker/tracker.service';
import { StateStorageService } from '../auth/state-storage.service';

@Injectable()
export class LoginService {

    constructor(
        private languageService: JhiLanguageService,
        private principal: Principal,
        private trackerService: JhiTrackerService,
        private authServerProvider: AuthServerProvider,
        private stateStorageService: StateStorageService,
        private eventManager: EventManager,
    ) { }

    login(credentials, callback?) {
        let cb = callback || function() { };

        return new Promise((resolve, reject) => {
            this.authServerProvider.login(credentials).subscribe(data => {
                this.principal.identity(true).then(account => {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account !== null) {
                        this.languageService.changeLanguage(account.langKey);
                        this.stateStorageService.setAccountLabel(account.firstName);
                    }
                    this.trackerService.sendActivity();
                    resolve(data);
                });
                return cb();
            }, err => {
                this.logout();
                reject(err);
                return cb(err);
            });
        });
    }

    loginWithToken(jwt, rememberMe) {
        return this.authServerProvider.loginWithToken(jwt, rememberMe);
    }

    logout() {
        this.authServerProvider.logout().subscribe();
        this.principal.authenticate(null);
        this.stateStorageService.deleteAccountLabel();
        this.stateStorageService.deleteCurrentTenantName();

        this.eventManager.broadcast({
            name: 'logoutSuccess',
            content: 'ok'
        });
    }

    getAccountLabel() {
        return this.stateStorageService.getAccountLabel();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/login/login.service.ts